import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import {
  defaultShouldDehydrateMutation,
  defaultShouldDehydrateQuery,
  type Mutation,
  type Query,
} from '@tanstack/react-query'
import { get as getItem, del as removeItem, set as setItem } from 'idb-keyval'
import { conversationQueryKeys } from 'v2/shared/utils/query-key-management'

export const idbPersister = createAsyncStoragePersister({
  storage: { getItem, setItem, removeItem },
})

const NEVER_PERSISTED = new Set<unknown>([conversationQueryKeys().crmContactBase[0]])

// CRM contact details are third-party PII; they must not outlive the tab in IndexedDB.
export const shouldPersistQuery = (query: Query) =>
  defaultShouldDehydrateQuery(query) && !NEVER_PERSISTED.has(query.queryKey[0])

// A Test lookup submitted offline is a paused mutation, which dehydrates with the phone it was given.
export const shouldPersistMutation = (mutation: Mutation) =>
  defaultShouldDehydrateMutation(mutation) &&
  !NEVER_PERSISTED.has(mutation.options.mutationKey?.[0])
